// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".validation-alert[data-v-30a61ef6]{width:100%;margin-bottom:.5rem!important}.validation-alert ul[data-v-30a61ef6]{margin-bottom:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
